import {getRestProps} from '../utils';
import Tooltip from '../tooltip';
import Icon from '../icon';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    className, children, label,
    isValid, isDirty, hideLabel, htmlFor,
    errorClassName, rules, fluid, _ellipsis,
} = self.get();

const classNameObj = {
    'k-form-item': true,
    'k-invalid': isDirty && isValid === false,
    'k-valid': isDirty && isValid === true,
    [className]: className,
    'k-fluid': fluid,
};

const labelWidth = self.form && self.form.get('labelWidth');
let labelStyle;
if (labelWidth != null) {
    if (/^\d+$/.test(labelWidth)) {
        labelStyle = {width: labelWidth + 'px'};
    } else {
        labelStyle = {width: labelWidth};
    }
}

const starOnRequired = self.form && self.form.get('starOnRequired');

    return h('div', {
        ...function() {try {return (getRestProps(self) )} catch(e) {_e(e)}}.call($this),
        'ev-change': function() {try {return (self._onChange )} catch(e) {_e(e)}}.call($this),
        'ev-focusout': function() {try {return (self._onFocusout )} catch(e) {_e(e)}}.call($this)
    }, [
        function() {try {return (!hideLabel )} catch(e) {_e(e)}}.call($this) ?
            h('label', {
                'htmlFor': function() {try {return (htmlFor )} catch(e) {_e(e)}}.call($this),
                'style': function() {try {return (labelStyle )} catch(e) {_e(e)}}.call($this)
            }, [
                function() {try {return (starOnRequired && rules && rules.required )} catch(e) {_e(e)}}.call($this) ?
                    h('span', null, '*', 'k-star') :
                    undefined,
                (_blocks['label'] = function(parent) {
                    return function() {try {return (label )} catch(e) {_e(e)}}.call($this);
                }) && (__blocks['label'] = function(parent) {
                    var args = arguments;
                    return blocks['label'] ? blocks['label'].apply($this, [function() {
                        return _blocks['label'].apply($this, args);
                    }].concat(__slice.call(args, 1))) : _blocks['label'].apply($this, args);
                }) && __blocks['label'].apply($this, [__noop])
            ], 'k-label') :
            undefined,
        h('div', null, [
            (_blocks['content'] = function(parent) {
                return function() {try {return (children )} catch(e) {_e(e)}}.call($this);
            }) && (__blocks['content'] = function(parent) {
                var args = arguments;
                return blocks['content'] ? blocks['content'].apply($this, [function() {
                    return _blocks['content'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['content'].apply($this, args);
            }) && __blocks['content'].apply($this, [__noop]),
            function() {try {return (self.get('isValid') === false )} catch(e) {_e(e)}}.call($this) ?
                h(Animate, {
                    'key': 'form-item-animate',
                    'className': _className(function() {try {return ({
                "k-error": true,
                [errorClassName]: errorClassName,
                'k-ellipsis': _ellipsis
            } )} catch(e) {_e(e)}}.call($this)),
                    'a:transition': 'c-fade',
                    'children': [
                        h('div', null, function() {try {return (self.get('message') )} catch(e) {_e(e)}}.call($this), 'k-error-message c-ellipsis', null, function(i) {widgets['error'] = i}),
                        h(Tooltip, {
                            'canHover': function() {try {return (true)} catch(e) {_e(e)}}.call($this),
                            'position': 'bottom',
                            'children': h(Icon, {
                                'className': 'ion-ios-information-outline k-error-more',
                                'size': 'small',
                                '_context': $this
                            }),
                            '_context': $this,
                            '_blocks': function(blocks) {
                                var _blocks = {}, __blocks = extend({}, blocks);
                                return ((_blocks['content'] = function(parent) {
                                    return function() {try {return (self.get('message') )} catch(e) {_e(e)}}.call($this);
                                }) && (__blocks['content'] = function(parent) {
                                    var args = arguments;
                                    return blocks['content'] ? blocks['content'].apply($this, [function() {
                                        return _blocks['content'].apply($this, args);
                                    }].concat(__slice.call(args, 1))) : _blocks['content'].apply($this, args);
                                }), __blocks);
                            }.call($this, {})
                        })
                    ],
                    '_context': $this
                }) :
                undefined
        ], 'k-content'),
        function() {try {return (blocks.append )} catch(e) {_e(e)}}.call($this) ?
            h('div', null, (_blocks['append'] = function(parent) {
                return null;
            }) && (__blocks['append'] = function(parent) {
                var args = arguments;
                return blocks['append'] ? blocks['append'].apply($this, [function() {
                    return _blocks['append'].apply($this, args);
                }].concat(__slice.call(args, 1))) : _blocks['append'].apply($this, args);
            }) && __blocks['append'].apply($this, [__noop]), 'k-append') :
            undefined
    ], _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)))
}